import React, { useEffect, useState } from 'react'
import { Modal, Button, message } from 'antd'
import assistance from './assets/assistance_new.jpg'
import randall from './assets/randall.jpg'
import micbg from './assets/micbg.png'
import './styles.scss'
import LiveKitRoomClient from './LiveKitRoomClient'
import MicrophoneLayout from './MicrophoneLayout'
import { api } from '../../services'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const serverUrl = process.env.REACT_APP_LIVEKIT_SEERVER_URL
const CoachModal = ({ visible, onClose, selectedCoacher }) => {
  const [connectStatus, setConnectStatus] = useState(false)
  const [coachStatus, setCoachStatus] = useState(false)
  const [connectedToLiveKit, setConnectedToLiveKit] = useState(null)
  const [isSpeaking, setIsSpeaking] = useState(null)
  const [token, setToken] = useState(null)
  const active_organization_id = useSelector(
    state => state.user.info.active_organization_id
  )
  const { t } = useTranslation()

  useEffect(() => {
    if (connectedToLiveKit === 'disconnected') {
      setConnectStatus(false)
    }
  }, [connectedToLiveKit])

  useEffect(() => {
    if (token) {
      setConnectStatus(true)
    }
  }, [token])

  const fetchLiveKitToken = async () => {
    try {
      let res = await api.sharebot.fetchLiveKitToken(active_organization_id, selectedCoacher)
      if (res.data && res.data.token) {
        setToken(res.data.token)
      }
    } catch (error) {
      message.error('Faled to connect to Coach!')
    }
  }
  return (
    <Modal
      visible={visible}
      footer={null}
      closable={false}
      centered
      width={900}
      className="coach-modal"
    >
      <div className="status-indicator">
        {connectedToLiveKit === 'connecting' && (
          <span className="dot blue">🔵 {t('v4:connecting')}</span>
        )}
        {connectedToLiveKit === 'connected' && (
          <>
            {coachStatus ? (
              <span className="dot green">🟢 {t('v5:connected')}</span>
            ) : (
              <span className="dot yellow">🟡 {t('v5:waiting_for_coach')}</span>
            )}
          </>
        )}
        {connectedToLiveKit === 'disconnected' && (
          <span className="dot red">🔴 {t('v5:disconnected')}</span>
        )}
      </div>
      <div className="main">
        <div className="main-intro">
          <p>
            {t('v5:coach_intro').replace(
              'DGF Logistic',
              selectedCoacher === 'Randall' ? 'Randall Craig' : 'DGF Logistic'
            )}
            <br />
            {t('v5:coach_help')}
          </p>
        </div>
        <img src={selectedCoacher === 'Randall' ? randall : assistance} alt="Coach" />
      </div>
      <LiveKitRoomClient
        connectStatus={connectStatus}
        setConnectedToLiveKit={setConnectedToLiveKit}
        setIsSpeaking={setIsSpeaking}
        setCoachStatus={setCoachStatus}
        token={token}
        serverUrl={serverUrl}
      />
      <div className={`micimage`}>
        {connectedToLiveKit !== 'connected' &&
          connectedToLiveKit !== 'connecting' && (
            <div className="mictext">
              <p>{t('v5:press_to_speak')}</p>
            </div>
          )}

        <div
          className="mic"
          onClick={() => {
            fetchLiveKitToken()
          }}
        >
          <MicrophoneLayout
            connectedToLiveKit={connectedToLiveKit}
            isSpeaking={isSpeaking}
          />
        </div>

        <img src={micbg} alt="micbg" />
      </div>

      <div className="leavebtn">
        <Button
          type="primary"
          size="large"
          style={{
            backgroundColor: '#6b7bff',
            borderRadius: 20,
            paddingLeft: 20,
            paddingRight: 20
          }}
          onClick={() => {
            setConnectStatus(false)
            setConnectedToLiveKit(null)
            setTimeout(() => {
              onClose()
            }, 300)
          }}
        >
          {t('v5:leave')}
        </Button>
      </div>
    </Modal>
  )
}

export default CoachModal
